<template>
  <div class="user-wrapper">
    <div class="content-box">
      <!-- <a href="https://pro.loacg.com/docs/getting-started" target="_blank">
        <span class="action">
          <a-icon type="question-circle-o"></a-icon>
        </span>
      </a>-->
      <!-- <notice-icon class="action"/> -->
      <a-dropdown>
        <span class="action ant-dropdown-link user-dropdown-menu">
          <a-avatar class="avatar" size="small" :src="avatar" />
          <span>{{ nickName }}</span>
        </span>
        <!-- <a-menu slot="overlay" class="user-dropdown-menu-wrapper"> -->
        <!-- <a-menu-item key="0">
            <router-link :to="{ name: 'center' }">
              <a-icon type="user"/>
              <span>个人中心</span>
            </router-link>
          </a-menu-item>
          <a-menu-item key="1">
            <router-link :to="{ name: 'settings' }">
              <a-icon type="setting"/>
              <span>账户设置</span>
            </router-link>
          </a-menu-item>
          <a-menu-item key="2" disabled>
            <a-icon type="setting"/>
            <span>测试</span>
          </a-menu-item>
          <a-menu-divider/>-->
        <!-- <a-menu-item key="2">
            <a href="javascript:;" @click="showEditPassword">
              <a-icon type="edit" />
              <span>修改密码</span>
            </a>
          </a-menu-item> -->
        <!-- <a-menu-item key="3">
            <a href="javascript:;" @click="handleLogout">
              <a-icon type="logout" />
              <span>退出登录</span>
            </a>
          </a-menu-item> -->
        <!-- </a-menu> -->
      </a-dropdown>
    </div>
    <Password ref="Password"></Password>
  </div>
</template>

<script>
import NoticeIcon from '@/components/NoticeIcon'
import { mapActions, mapGetters } from 'vuex'
import Password from './Password'
import Vue from 'vue'

export default {
  name: 'UserMenu',
  components: {
    NoticeIcon,
    Password
  },
  data() {
    return {
      nickName: ''
    }
  },
  computed: {
    ...mapGetters(['avatar'])
  },
  mounted() {
    const userInfo = Vue.ls.get('USER_INFO')
    console.log(userInfo, 'userInfouserInfouserInfouserInfo')
    this.nickName = userInfo.user.nickName
  },
  methods: {
    ...mapActions(['Logout']),
    showEditPassword() {
      this.$refs.Password.show()
    },
    handleLogout() {
      this.$confirm({
        title: '提示',
        content: '真的要退出登录吗 ?',
        onOk: () => {
          return this.Logout({})
            .then(() => {
              setTimeout(() => {
                window.location.reload()
              }, 16)
            })
            .catch(err => {
              this.$message.error({
                title: '错误',
                description: err.message
              })
            })
        },
        onCancel() {}
      })
    }
  }
}
</script>
